import Filter from './filter/Filter'
import './Modal.css'
import { useState } from 'react'

function Modal(props) {
    const [hoverBack, setHoverBack] = useState(false)

    const closeModal = () => {
        let modal = document.getElementById("myModal");
        modal.style.display = "none";
    }

    return (
        <div id="myModal" className="modal" data-testid="filterModal">
            <div className="modalContent">
                <div className="closeArea">
                    <img 
                    className="closeButton"
                    src={hoverBack ? "/img/back-hover.png" : "/img/back.png"}
                    onMouseOver={() => setHoverBack(true)}
                    onMouseOut={() => setHoverBack(false)}
                    onClick={closeModal} 
                    alt="Stäng" 
                    />
                </div>
                <Filter 
                    showEuropean={props.showEuropean}
                    setShowEuropean={props.setShowEuropean}
                    filterCategory={props.filterCategory}
                    setFilterCategory={props.setFilterCategory}
                />
            </div>
        </div>
    )
}

export default Modal